import { mapActions, mapGetters } from 'vuex';
import { searchContacts } from '@/api/contact';
// import { debounce } from 'lodash';
import validator from 'validator';

export default {
  data () {
    return {
      searchTerm: null
    };
  },
  computed: {
    ...mapGetters('AppStore', {
      inMeeting: 'inMeeting'
    }),
    ...mapGetters('ContactStore', {
      favorites: 'favorites',
      searchResults: 'searchResults'
    }),
    ...mapGetters('ConversationStore', {
      conversations: 'conversations'
    }),
    chatSearchResults () {
      const self = this;
      return [
        ...this.filterConversations(),
        ...this.searchResults.filter(item => {
          if (item.userhash) {
            return !self.conversationExist(item.userhash);
          }
          return false;
        })
      ];
    },
    dialContact () {
      return this.searchTerm &&
        this.searchTerm.trim().length > 0 &&
        !this.isTermInResult &&
        (validator.isNumeric(this.searchTerm) ||
          validator.isURL(this.searchTerm))
        ? {
          name: this.searchTerm,
          room: this.searchTerm,
          presence: true,
          userstatus: 1
        }
        : null;
    },
    filteredFavs () {
      const self = this;
      return this.favorites
        .filter(item => !!item.userhash)
        .map(item => {
          const result = self.conversationExist(item.userhash);
          return result || item;
        });
    },
    formattedChatSearchResults () {
      return this.showSearchResult || this.chatSearchResults.length > 0
        ? this.chatSearchResults
        : this.filteredFavs;
    },
    isTermInResult () {
      return !!this.searchResults.find(element => {
        return element.room === this.searchTerm;
      });
    },
    showSearchResult () {
      return this.searchTerm && this.searchTerm.length > 0;
    }
  },
  watch: {
    searchTerm (newValue, oldValue) {
      this.searchAction(newValue);
    }
  },
  mounted () {
    this.$eventBus.$on(
      'native-messageFromControl',
      this.onMessageFromControlInSearch
    );
    this.setSearchResults(this.inMeeting ? this.favorites : []);
  },
  beforeDestroy () {
    this.$eventBus.$off(
      'native-messageFromControl',
      this.onMessageFromControlInSearch
    );
  },
  methods: {
    ...mapActions('ContactStore', ['setSearchResults']),
    async clearSearch () {
      this.searchTerm = null;
      this.setSearchResults(this.inMeeting ? this.favorites : []);
      this.sendSearchResultsToControls(
        this.inMeeting ? this.favorites : []
      );
    },
    conversationExist (userhash) {
      return this.conversations.find(item => {
        if (!item.group) {
          return !!item.participants.find(user => user.userhash === userhash);
        }
        return false;
      });
    },
    filterConversations () {
      const self = this;
      return this.conversations.filter(item => {
        if (
          item.group &&
          self.searchTerm &&
          self.searchTerm.trim().length > 0 &&
          item.name &&
          item.name.search(self.searchTerm) > 0
        ) {
          return true;
        } else {
          return !!this.searchResults.find(
            result => item.participants[0] && result.userhash === item.participants[0].userhash
          );
        }
      });
    },
    onMessageFromControlInSearch ({ message }) {
      try {
        if (message.scope === 'search') {
          if (message.type === 'input' && message.data.field === 'searchTerm') {
            this.searchTerm = message.data.value;
          }
        }
      } catch (err) { }
    },
    removeIfUserExist (result) {
      if (this.user && result) {
        const index = result.findIndex(contact => {
          if (
            this.user.hash &&
            contact.userhash &&
            contact.userhash === this.user.hash
          ) {
            return true;
          }

          if (
            contact.room &&
            this.user.room &&
            contact.room === this.user.room
          ) {
            return true;
          }

          if (
            contact.number_short &&
            this.user.room &&
            contact.number_short === this.user.room
          ) {
            return true;
          }
          return false;
        });
        if (index > -1) {
          result.splice(index, 1);
        }
      }
      return result;
    },
    async searchAction (term) {
      let result = this.inMeeting ? this.favorites : [];
      if (term && term.trim().length > 0) {
        try {
          result = await searchContacts(term.trim(), !!this.user, !!this.$_CONFIG.appconfig.SEARCH_ONLY_INSIDE_DOMAIN);
          result = this.removeIfUserExist(result);
        } catch (error) {
          result = [];
        }
      }
      this.setSearchResults(result);
      this.sendSearchResultsToControls(result);
    },
    sendSearchResultsToControls (results) {
      this.$eventBus.$emit('sendToControls', {
        type: 'task',
        scope: 'search',
        data: {
          task: 'setSearchResults',
          param: results,
          searchTerm: this.searchTerm
        }
      });
    }
  }
};
